import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Een aanvraag naar PlayStats kreeg helemaal geen antwoord (status 0). De
 * foutinterceptor meldt dat hier; TagsOpPcService luistert en zet dan
 * "geen internet" aan (Emergency control in het menu, tags naar de pc).
 *
 * Bewust zonder afhankelijkheden: de interceptor draait bij elke aanvraag en
 * mag niet de hele studio-verbinding (sockets e.d.) meetrekken.
 */
@Injectable({ providedIn: 'root' })
export class GeenVerbindingService {
  private readonly melding = new Subject<void>();
  public readonly meldingen$: Observable<void> = this.melding.asObservable();

  public meld(): void {
    this.melding.next();
  }
}
